import { Button, Grid2, Snackbar, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useEffect, useRef, useState } from "react";
import { Label } from "flowbite-react";
import defaultImgg from "../../assets/images/defaultImgg.svg";
import uploadIcon from '../../assets/images/uploadIcon.svg';
import { useNavigate } from "react-router-dom";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import axios from "axios";

const GeneralSettings = () =>{
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [uploadedImage, setUploadedImage] = useState(defaultImgg); // Manage image state
    const [uploadedFavicon, setUploadedFavicon] = useState(defaultImgg);
    const [clientName, setClientName] = useState('');
    const [supportEmail, setSupportEmail] = useState('');
    const fileInputRef = useRef(null);
    const faviconInputRef = useRef(null);

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;

    const handleUploadClick = () => {
        // Trigger file input on click
        fileInputRef.current.click();
    };

    const handleUploadFavicon = () => {
        faviconInputRef.current.click();
    }

    const handleFileChange = (type) => async(event) => {
        const file = event.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append('image', file);
    
            try {
                const response = await axios.post(operationsUrl + '/upload_image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    
                const s3Url = response.data.url;
                const newImage = {
                    name: file.name,
                    src: s3Url,
                    isUploaded: true,
                };
    
                if(type=='brand') setUploadedImage(s3Url);
                if(type=='favicon') setUploadedFavicon(s3Url);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }
    };

    const fetchGeneralSettings = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/fetch_client_info';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setDataa(response.data);
                const fetchedData = response.data[0];
                setClientName(fetchedData.client_name);
                setSupportEmail(fetchedData.support_email);
                if(fetchedData.brand_logo) setUploadedImage(fetchedData.brand_logo);
                if(fetchedData.favicon) setUploadedFavicon(fetchedData.favicon);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchGeneralSettings();
    },[])

    const saveData = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            client_name: clientName,
            support_email: supportEmail,
            // brand_logo: uploadedImage,
            // favicon: uploadedFavicon
        };
        if(uploadedImage!=defaultImgg) payload['brand_logo']=uploadedImage;
        if(uploadedFavicon!=defaultImgg) payload['favicon']=uploadedFavicon;

        try {
            const url = operationsUrl + '/settings/update_client_info';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                General Settings
            </Typography>

            <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>
                <Typography sx={{color:'#4E545D', fontSize:'24px'}}> Client Settings</Typography>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item size={6}>
                        <Label>Client Name<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Client Name" fullWidth variant="outlined" type="text" 
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>

                    <Grid2 item size={6}>
                        <Label>Support Email<span style={{ color: 'red' }}>*</span></Label>
                        <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                            placeholder="Support Email" fullWidth variant="outlined" type="text" 
                            value={supportEmail}
                            onChange={(e) => setSupportEmail(e.target.value)}
                            InputProps={{
                                inputProps: { min: 0 },
                                style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                            }}
                        />
                    </Grid2>
                </Grid2>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item sx={{backgroundColor:'#F9F9F9', padding:'12px', borderRadius:'8px'}} size={6}>
                        <Typography sx={{color:'#4E545D'}}>Brand Logo</Typography>
                    </Grid2>

                    <Grid2 item sx={{backgroundColor:'#F9F9F9', padding:'12px', borderRadius:'8px'}} size={6}>
                        <Typography sx={{color:'#4E545D'}}>Favicon</Typography>
                    </Grid2>
                </Grid2>

                <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                    <Grid2 item sx={{display:'flex'}} size={6}>
                        <Grid2 item>
                            {/* <img src={defaultImgg} alt="defaultProfile" /> */}
                            <img
                                src={uploadedImage}
                                alt="uploadedProfile"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                }}
                            />
                        </Grid2>
                        <Grid2 item sx={{ marginLeft:'12px', marginTop:'2%'}}>
                            <Typography sx={{fontSize:'12px', color:'#83888E', marginBottom:'8%'}}>Upload Brand Logo</Typography>
                            <Grid2 item onClick={handleUploadClick} sx={{border:'1px solid #D1D5DB', display:'flex', padding:'4px 8px', borderRadius:'8px', width:'150px', 
                            cursor:'pointer', "&:hover": { borderColor: "#0065FF"},}}>
                                <Grid2><img src={uploadIcon} alt="uploadIcon" /></Grid2>
                                <Typography sx={{fontSize:'14px', color:'#83888E', marginTop:'4%'}}>Upload</Typography>

                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleFileChange('brand')}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>

                    <Grid2 item sx={{display:'flex'}} size={6}>
                        <Grid2 item>
                            <img
                                src={uploadedFavicon}
                                alt="uploadedFavicon"
                                style={{
                                    width: "100px",
                                    height: "100px",
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                }}
                            />
                        </Grid2>
                        <Grid2 item sx={{ marginLeft:'12px', marginTop:'2%'}}>
                            <Typography sx={{fontSize:'12px', color:'#83888E', marginBottom:'8%'}}>Upload Favicon</Typography>
                            <Grid2 item onClick={handleUploadFavicon} sx={{border:'1px solid #D1D5DB', display:'flex', padding:'4px 8px', borderRadius:'8px', width:'150px', 
                            cursor:'pointer', "&:hover": { borderColor: "#0065FF"},}}>
                                <Grid2><img src={uploadIcon} alt="uploadIcon" /></Grid2>
                                <Typography sx={{fontSize:'14px', color:'#83888E', marginTop:'4%'}}>Upload</Typography>

                                <input
                                    type="file"
                                    accept="image/*"
                                    ref={faviconInputRef}
                                    style={{ display: "none" }}
                                    onChange={handleFileChange('favicon')}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </Grid2>

                <Grid2 item sx={{marginTop:'24px', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'24px'}} size={12}>
                            
                    <Button onClick={saveData} variant="contained">Update</Button>
                    
                </Grid2>

            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

        </div>

    )
}
export default GeneralSettings;